
/**
 * Utility functions for formatting point labels
 */

/**
 * Format a point identifier into a human-readable string
 */
export const getFormattedPoint = (point: string): string => {
  // Handle specific point formats based on level
  if (point === 'G') return 'Point G';
  if (point === 'H') return 'Point H';
  if (point === 'I') return 'Point I';
  
  if (point.startsWith('A')) return `Point A${point.slice(1)}`;
  if (point.startsWith('B')) return `Point B${point.slice(1)}`;
  if (point.startsWith('C')) return `Point C${point.slice(1)}`;
  if (point.startsWith('D')) return `Point D${point.slice(1)}`;
  if (point.startsWith('E')) return `Point E${point.slice(1)}`;
  if (point.startsWith('F')) return `Point F${point.slice(1)}`;
  if (point.startsWith('G')) return `Point G${point.slice(1)}`;
  if (point.startsWith('H')) return `Point H${point.slice(1)}`;
  if (point.startsWith('I')) return `Point I${point.slice(1)}`;
  
  // Special cases for level 3
  if (point === 'TerPlatA') return 'Terrain plat - Point A';
  if (point === 'PenteDroitA1') return 'Pente droite - Point A1';
  if (point === 'PenteGaucheA2') return 'Pente gauche - Point A2';
  if (point === 'ChipRoulA') return 'Chip roulé - Point A';
  if (point === 'ChipRoulPenteA1') return 'Chip roulé en pente - Point A1';
  if (point === 'ChipRoulPenteA5') return 'Chip roulé en pelouse - Point A5';
  if (point === 'WedgingA') return 'Wedging - Point A';
  if (point === 'WedgingA1') return 'Wedging - Point A1';
  if (point === 'WedgingA2') return 'Wedging - Point A2';
  if (point === 'BunkerA') return 'Bunker - Point A';
  if (point === 'IronA') return 'Iron - Point A';
  if (point === 'FairwayWoodA') return 'Fairway Wood - Point A';
  if (point === 'DriverA') return 'Driver - Point A';
  
  return `Point ${point}`;
};
